import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const GoogleAnalyticsIntegrationSchema = z.object({
  id: z.string(),
  name: z.string(),
  // Null until a Mint 2.0 backend-owned OAuth integration is configured.
  accountId: z.string().nullable(),
  propertyId: z.number().nullable(),
  isRefreshTokenValid: z.boolean(),
  isActive: z.boolean().nullish(),
  usingInCampaigns: z.boolean().optional(),
  userUpdatedAt: z.string().nullish(), //.nullable(),
  userUpdatedId: z.coerce.string().nullish(), //.nullable(),
  usingInAccounts: z.boolean().nullish(), //.nullable(),
  expired: z.boolean().nullish(), //.nullable(),
});

export const GoogleAnalyticsResponseSchema = createResponseSchema(
  GoogleAnalyticsIntegrationSchema,
);

const GA4IntegrationOauthUpdateItem = z.object({
  url: z.string(),
});

export const GA4IntegrationOauthUpdateResponseSchema = z.object({
  data: z.object({
    items: z.array(GA4IntegrationOauthUpdateItem),
  }),
});

export const GA4IntegrationOauthCreateRequestSchema = z.object({
  name: z.string(),
  accountId: z.string(),
  propertyId: z.string(),
});

export const GA4IntegrationCreateRequestSchema = z.object({
  state: z.string(),
  code: z.string(),
});

export const GA4IntegrationCreateResponseSchema = createResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
    accountId: z.string(),
    propertyId: z.number(),
  }),
);

export const GA4IntegrationUpdateRequestSchema = z.object({
  name: z.string(),
});

export const GA4IntegrationOauthUrlQuerySchemaLegacy = z.object({
  integrationId: z.string().nullable(),
});

export const GA4IntegrationOauthUrlResponseSchemaLegacy = createResponseSchema(
  z.object({
    authorizationUrl: z.string(),
    oauthFlowId: z.string(),
  }),
);

export const GA4IntegrationOauthUrlRequestSchema = z.object({
  name: z.string().optional(),
  integrationId: z.string().optional(),
});

export const GA4IntegrationOauthUrlResponseSchema = createResponseSchema(
  z.object({
    authorizationUrl: z.string(),
  }),
);

export const GA4ExternalAccountsQuerySchema = z.object({
  integrationId: z.string(),
});

export const GA4ExternalPropertySummarySchema = z.object({
  property: z.string(),
  displayName: z.string(),
  propertyType: z.string().nullish(),
  parent: z.string().nullish(),
});

export const GA4ExternalAccountSchema = z.object({
  account: z.string(),
  displayName: z.string(),
  propertySummaries: z.array(GA4ExternalPropertySummarySchema).nullish(),
});

export const GA4ExternalAccountsResponseSchema = createResponseSchema(
  GA4ExternalAccountSchema,
);

// account_id and property_id are an atomic pair: send both or neither.
export const GA4IntegrationUpdateV3RequestSchema = z.object({
  name: z.string().optional(),
  accountId: z.string().optional(),
  propertyId: z.number().optional(),
});

export const GA4IntegrationUpdateV3ResponseSchema = createResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
    accountId: z.string().nullable(),
    propertyId: z.number().nullable(),
  }),
);

export const GA4IntegrationCreateV3RequestSchema = z.object({
  oauthFlowId: z.string(),
  name: z.string(),
  accountId: z.string(),
  propertyId: z.number(),
});

export const GA4IntegrationOauthCallbackQuerySchema = z.object({
  oauthFlowId: z.string(),
  state: z.string(),
  code: z.string(),
  integrationId: z.string().nullable(),
});

export const GA4IntegrationOauthCallbackResponseSchema = createResponseSchema(
  z.object({
    reconnectState: z.string(),
  }),
);
